import qs from 'qs';
import jsonUrl from "json-url";

const codec = jsonUrl("lzma");

const urlToJson = async (string, extras = false) => {
  if (string === "" || string === false || typeof string !== 'string') return {};

  string = string.replace(/^[?]/, '');

  let search = qs.parse(string, {
    arrayFormat: 'indices'
  });

  // The query string may contain params other than the compressed filters
  // (e.g. `?ws=<workspaceId>`), leaving `search._` undefined. Calling
  // codec.decompress(undefined) throws inside json-url, so bail out early and
  // return an empty result (with the parsed params when `extras` is set).
  if (search?._ == null) {
    return extras ? { ...search ?? {}, _: {} } : {};
  }

  let output = await codec.decompress(search?._);

  if (extras) {
    return {
      ...search ?? {},
      _: output, 
    };
  } else {
    return output;
  }
};

export default urlToJson;
